export const POPUP_LOGIN_QUERY_KEY = 'popup_login';
export const POPUP_LOGIN_QUERY_VALUE = '1';
export const POPUP_LOGIN_MESSAGE_TYPE = 'vidu.auth.popup.success';
const POPUP_LOGIN_MESSAGE_SOURCE = 'vidu.auth.popup';

export interface PopupLoginSuccessMessage {
  type: typeof POPUP_LOGIN_MESSAGE_TYPE;
  source: typeof POPUP_LOGIN_MESSAGE_SOURCE;
}

export const createPopupLoginSuccessMessage = (): PopupLoginSuccessMessage => ({
  type: POPUP_LOGIN_MESSAGE_TYPE,
  source: POPUP_LOGIN_MESSAGE_SOURCE,
});

export const isPopupLoginSuccessMessage = (data: unknown): data is PopupLoginSuccessMessage => {
  if (!data || typeof data !== 'object') {
    return false;
  }

  const message = data as Partial<PopupLoginSuccessMessage>;

  return message.type === POPUP_LOGIN_MESSAGE_TYPE && message.source === POPUP_LOGIN_MESSAGE_SOURCE;
};
